export default "__VITE_ASSET__BXeAN89z__"